<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Card di contenimento della pagina -->
    <b-card title="Delega Consulenza" class="mr-1 ml-1">

      <!-- Card di contenimento della tabella con le apy key dei gestori -->
      <b-card no-body class="mt-3">
        <b-card-header>
          <h5><font-awesome-icon icon="list-ul" class="ml-1" size="lg"/> Consulenti Attivi</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col>
              <p>In questa tabella sono riportati gli accessi relativi ai consulenti attivi per la tua azienda. Con tale accesso i consulenti
                 possono operare sui dati aziendali. Se vuoi revocare l'accesso ad un consulente clicca sul pulsante di revoca nella colonna "Azioni"
                 identificato da questa icona: <b-icon icon="x-octagon-fill"></b-icon></p>
            </b-col>
          </b-row>
          <b-row>
            <!-- Select per la scelta del numero di elementi da visualizzare -->
            <b-col cols="12" md="2">
              <b-form-group id="group-page-size"
                  label="Elementi visualizzati:"
                  label-for="page-size">
                <b-form-select id="page-size"
                              v-model="datatable.page_size"
                              :options="datatable.page_size_opt">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tabella delle chiavi -->
            <b-col>
              <b-table responsive
                      ref="consultanttable"
                      stacked="md"
                      :per-page="datatable.page_size"
                      :current-page="datatable.page"
                      :items="get_table_item"
                      :fields="datatable.fields"
                      :busy="datatable.busy"
                      show-empty>


                <!-- Ridefiniamo la cella della data creazione per porla nel formato italiano -->
                <template #cell(created)="data">
                  {{ data.value | toitadatetime }}
                </template>

                <!-- Definiamo la colonna delle azioni -->
                <template #cell(action)="data">
                  <!-- Cancellazione della chiave ( revoca autorizzazione all'api user ) -->
                  <b-link v-b-tooltip.hover.bottom="'Revoca autorizzazioni'"
                          @click="cancella_chiave(data.item.id)"
                          class="mr-2">
                    <b-icon icon="x-octagon-fill"></b-icon>
                  </b-link>
                </template>

                <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                      chiamata la funzione che prende i dati get_table_items --->
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                    <strong class="text-primary">Caricamento...</strong>
                  </div>
                </template>

                <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                      la proprietà "show-empty" alla tabella -->
                <template v-slot:empty>
                  <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/> Non risulta associato nessun consulente</p>
                </template>
              </b-table>
              <!-- Paginatore della tabella -->
              <b-pagination v-model="datatable.page" :per-page="datatable.page_size" :total-rows="datatable.items_tot" align="center"></b-pagination>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

    </b-card>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
    name: 'TabellaConsulenti',
    data () {
      return {
        tagline_elem : [ { text : "Delega Consulenza", link: "office-consulenti" } ],

        // Elementi per la datatable
        datatable : {

          // Pone la tabella in stato busy. In fase di
          // caricamento dati è gestito in automatico,
          // ci serve invece quando eseguiamo le azioni
          // come per esempio la cancellazione delle chiavi.
          busy: false,

          // Pagina attuale
          page : 1,

          // Numero di elementi per pagina
          page_size : 50,

          // Elementi totali
          items_tot : 0,

          // Numero di pagine che è possibile visualizzare
          page_size_opt: [
            { value: 10,  text: '10'  },
            { value: 25,  text: '25'  },
            { value: 50,  text: '50'  },
            { value: 100, text: '100' },
            { value: 500, text: '500' }
          ],

          // Campi della tabella
          fields : [
            {
              key: 'api_user_name',
              label: 'Identificativo',
              sortable: true,
              thClass: 'text-center',
              tdClass: 'text-center'
            },
            {
              key: 'created',
              label: 'Data Attivazione',
              sortable: true,
              thClass: 'text-center',
              tdClass: 'text-center'
            },
            // Colonna virtuale per ospitare le icone delle azioni
            {
              key : 'action',
              label: 'Azioni',
              sortable: false,
              thClass: 'text-center',
              tdClass: 'text-center'
            }
          ]
        }
      }
    },
    methods: {
      /**
       * Funzione per prendere gli elementi della tabella dal backend
       */
      get_table_item : function ( ctx, callback ) {

        const call_url = apiUrl.pdoppiaapi.get_chiavi_pubbliche;

        // Usiamo il parametro onlyapiuser a true per avere solo le chiavi dell'azienda
        // effettivamente associate ad un apiuser, tralasciando le altre che non lo sono
        // perchè magari aggiunte per il welfarebridge.
        const params =  { page : ctx.currentPage, page_size : ctx.perPage, onlyapiuser : true };

        axios.get( call_url, { params : params } )
        .then( ( response ) => {

          // Elementi totali
          this.datatable.items_tot = response.data.count;

          // Prendiamo i dati che ci servono e togliamo
          // quelli della paginazione
          const items = response.data.results;
          callback( items )
        })
        .catch( ( error ) => {
          generalLib.backend_error_message_box( this, error.response.data );
          callback([])
        });

        // Must return null or undefined to signal b-table that callback is being used
        return null
      },
      /**
       * Esegue la cancellazione della chiave pubblica il cui id è passato alla funzione.
       * Chiede conferma prima di proseguire.
       *
       * - keyid: id della chiave pubblica da cancellare.
       */
      cancella_chiave : function ( keyid ) {
        const message = "Revocando l'autorizzazione il consulente non sarà più in grado di " +
                        "accedere ai dati della tua azienda. Sei sicuro di continuare?";
        this.$bvModal.msgBoxConfirm( message, {
          title: 'Revoca autorizzazione.',
          centered: true
        })
        .then( ( ok ) => {
          if ( !ok ) return;

          const call_url = apiUrl.pdoppiaapi.delete_chiave_pubblica.replace('@keyid', keyid );
          this.datatable.busy = true;

          axios.delete( call_url )
          .then( ( response ) => {
            // La chiamata torna un 204 No content in caso di successo
            // andiamo quindi a refresciare il contenuto della tabella
            // e a notificare l'avvenuta operazione all'utente
            this.datatable.busy = false;
            this.$bvModal.msgBoxOk('Revoca eseguita')
            .then( (value) => {
              this.$refs.consultanttable.refresh();
            })
          })
          .catch( ( error ) => {
            this.datatable.busy = false;
            generalLib.backend_error_message_box( this, error.response.data );
          });

        })
      }
    },
    components: {
      PageTagline,
      SwitcherAziende
    }
}
</script>


<style scoped></style>